/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SubtotalInputs */

const en_subtotal = /** @type {(inputs: SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtotal`)
};

const th_subtotal = /** @type {(inputs: SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยอดรวมย่อย`)
};

const ja_subtotal = /** @type {(inputs: SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小計`)
};

const fr_subtotal = /** @type {(inputs: SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-total`)
};

const es_subtotal = /** @type {(inputs: SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtotal`)
};

const ru_subtotal = /** @type {(inputs: SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промежуточный итог`)
};

const zh_subtotal = /** @type {(inputs: SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小计`)
};

const vi_subtotal = /** @type {(inputs: SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạm tính`)
};

/**
* | output |
* | --- |
* | "Subtotal" |
*
* @param {SubtotalInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const subtotal = /** @type {((inputs?: SubtotalInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SubtotalInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_subtotal(inputs)
	if (locale === "ja") return ja_subtotal(inputs)
	if (locale === "fr") return fr_subtotal(inputs)
	if (locale === "es") return es_subtotal(inputs)
	if (locale === "ru") return ru_subtotal(inputs)
	if (locale === "zh") return zh_subtotal(inputs)
	if (locale === "vi") return vi_subtotal(inputs)
	return en_subtotal(inputs)
});